import { useTranslations } from "next-intl";
import PageSection from "@/common/page-section.common";
import { Typography } from "@mui/material";
import Card from "@mui/material/Card";
import BusinessesIcon from "./icons/businesses-icon.component";
import IndividualsIcon from "./icons/individuals-icon.component";
import RealEstateIcon from "./icons/real-estate-icon.component";
export const WhoCanApply = () => {
  const t = useTranslations();
  return <PageSection heading="Who Can Apply">
      <div className="flex justify-between flex-wrap gap-8">
        <Card>
          <IndividualsIcon />
          <Typography variant="h5">{t("Individual Landowners")}</Typography>
          <Typography sx={{
          textAlign: "center"
        }}>{t("Private individuals owning land adjacent to forest areas")}</Typography>
        </Card>
        <Card>
          <BusinessesIcon />
          <Typography variant="h5">{t("Businesses")}</Typography>
          <Typography sx={{
          textAlign: "center"
        }}>{t("Commercial entities operating near forest boundaries")}</Typography>
        </Card>
        <Card>
          <RealEstateIcon />
          <Typography variant="h5">{t("Real Estate Developers")}</Typography>
          <Typography sx={{
          textAlign: "center"
        }}>{t("Companies involved in property development projects")}</Typography>
        </Card>
      </div>
    </PageSection>;
};
export default WhoCanApply;